import { IChipListV4 } from '@nocode/types';
import { StyleSheet } from 'react-native';
import { checkFont, getBorderStyle, getBorderWidth } from '../../func';
import { isCheckColor } from '../../shared';

const createStyles = (attrs: IChipListV4) => {
  const itemMargin = attrs.style?.gap ?? 0;

  const chipStyle = attrs.style.tag ?? {};
  const chipBackgroundColor = chipStyle.backgroundColor;
  const chipBorderColor = chipStyle.borderColor;
  const chipShadow = attrs.style.tag?.shadow;
  const titleStyle = attrs.attributes.title?.style ?? {};
  const cardCoverStyle = attrs.attributes.cardCover?.style ?? {};

  const itemSize = (chipStyle?.height as number) || 32;

  return StyleSheet.create({
    chip: {
      height: itemSize,
      marginHorizontal: itemMargin / 2,
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      marginTop: itemSize * 0.1,
      marginBottom: itemSize * 0.1,
      shadowColor: chipShadow?.color,
      shadowOffset: {
        width: chipShadow?.x ?? 0,
        height: chipShadow?.y ?? 0,
      },
      shadowOpacity: chipShadow?.blur,
      shadowRadius: chipShadow?.size,
      elevation: 5,
      backgroundColor:
        typeof chipBackgroundColor === 'string' &&
        isCheckColor(chipBackgroundColor)
          ? chipBackgroundColor
          : '#ffffff',
      borderRadius: chipStyle.borderRadius,
      ...(chipStyle.borderWidth !== 0 && {
        borderColor:
          typeof chipBorderColor === 'string' && isCheckColor(chipBorderColor)
            ? chipBorderColor
            : '#e0e0e0',
        borderWidth: chipStyle.borderWidth,
        borderStyle: chipStyle.borderStyle,
      }),
    },
    avatar: {
      display: 'flex',
      alignItems: 'center',
      height: itemSize * 0.6,
      width: itemSize * 0.6,
      marginTop: itemMargin * 0.5,
      marginBottom: itemMargin * 0.5,
      borderColor: cardCoverStyle.borderColor,
      borderWidth: getBorderWidth(
        cardCoverStyle.borderWidth ?? 0,
        (cardCoverStyle.borderStyle ?? 'solid') as
          | 'solid'
          | 'dotted'
          | 'dashed'
          | 'none'
      ),
      borderRadius: cardCoverStyle.borderRadius,
      borderStyle: getBorderStyle(
        (cardCoverStyle.borderStyle ?? 'solid') as
          | 'solid'
          | 'dotted'
          | 'dashed'
          | 'none'
      ),
    },
    text: {
      fontFamily: checkFont(titleStyle.fontFamily),
      fontSize: titleStyle.fontSize,
      color: titleStyle.color,
      fontWeight: titleStyle.fontWeight,
    },
  });
};

export default createStyles;
